module.exports = __webpack_public_path__ + "img/flisolinfo.62e289c6.jpg";